package com.eladfinish.bible.contest.screens.browse.contentOfChapter.model

import androidx.compose.runtime.Stable
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.CompleteType
import com.eladfinish.bible.contest.screens.chapterComplete.features.progressiveExposure.ProgressiveExposureState
import com.eladfinish.bible.contest.screens.chapterComplete.features.shuffle.RevealCardData
import com.eladfinish.bible.contest.screens.chapterComplete.model.SavedCompletionData
import com.eladfinish.bible.contest.screens.chapterComplete.model.UserCompletionsModel
import com.eladfinish.bible.contest.text.SpannableStringKMP
import kotlinx.collections.immutable.ImmutableList

@Stable
sealed interface ContentMode {
    data object Normal : ContentMode

    data class ChapterComplete(
        val type: CompleteType,
        val output: SpannableStringKMP,
    ) : ContentMode

    data class SavedCompletion(
        val data: SavedCompletionData,
        val output: SpannableStringKMP,
    ) : ContentMode

    data class UserCompletions(
        val model: UserCompletionsModel,
        val output: SpannableStringKMP,
    ) : ContentMode

    data class ProgressiveExposure(
        val state: ProgressiveExposureState,
        val output: SpannableStringKMP,
    ) : ContentMode

    data class ShuffledVerses(
        val verses: ImmutableList<RevealCardData>,
    ) : ContentMode
}
